var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPMapLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:my-location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9969 22.9508V20.9508C8.91354 20.7174 7.12587 19.8551 5.63387 18.3638C4.14187 16.8724 3.27954 15.0848 3.04688 13.0008H1.04688V11.0008H3.04688C3.28021 8.91745 4.14288 7.12978 5.63488 5.63778C7.12688 4.14578 8.91421 3.28345 10.9969 3.05078V1.05078H12.9969V3.05078C15.0802 3.28411 16.8679 4.14678 18.3599 5.63878C19.8519 7.13078 20.7142 8.91811 20.9469 11.0008H22.9469V13.0008H20.9469C20.7135 15.0841 19.8512 16.8718 18.3599 18.3638C16.8685 19.8558 15.0809 20.7181 12.9969 20.9508V22.9508H10.9969ZM11.9969 19.0008C13.9302 19.0008 15.5802 18.3174 16.9469 16.9508C18.3135 15.5841 18.9969 13.9341 18.9969 12.0008C18.9969 10.0674 18.3135 8.41745 16.9469 7.05078C15.5802 5.68411 13.9302 5.00078 11.9969 5.00078C10.0635 5.00078 8.41354 5.68411 7.04688 7.05078C5.68021 8.41745 4.99688 10.0674 4.99688 12.0008C4.99688 13.9341 5.68021 15.5841 7.04688 16.9508C8.41354 18.3174 10.0635 19.0008 11.9969 19.0008ZM11.9969 16.0008C10.8969 16.0008 9.95521 15.6091 9.17188 14.8258C8.38854 14.0424 7.99687 13.1008 7.99687 12.0008C7.99687 10.9008 8.38854 9.95912 9.17188 9.17578C9.95521 8.39245 10.8969 8.00078 11.9969 8.00078C13.0969 8.00078 14.0385 8.39245 14.8219 9.17578C15.6052 9.95912 15.9969 10.9008 15.9969 12.0008C15.9969 13.1008 15.6052 14.0424 14.8219 14.8258C14.0385 15.6091 13.0969 16.0008 11.9969 16.0008Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPMapLocation);
export default __webpack_public_path__ + "static/media/p_map_location.b489bd9380700ba2f8a40b687f43b6c6.svg";
export { ForwardRef as ReactComponent };